// extracted by mini-css-extract-plugin
export default {"HeaderNavItemWrapper":"HeaderNavItemWrapper_HeaderNavItemWrapper__61RFQ"};